/* ============================================================
   PEOPLE GET UP — Custom Product Buy-Box behavior
   Vanilla IIFE. Purchase-type + pack selection -> live price,
   variant + selling-plan wiring, AJAX add -> cart drawer.
   ============================================================ */
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function init(box) {
    if (!box || box.__pguBBInit) return;
    box.__pguBBInit = true;

    var discount = parseFloat(box.getAttribute('data-sub-discount')) || 20;
    var sellingPlanId = box.getAttribute('data-selling-plan') || '';

    var ptypeInputs = $$('[data-pgu-ptype]', box);
    var packs = $$('[data-pgu-pack]', box);
    var variantSelect = $('[data-pgu-variant-select]', box);
    var sellingPlanInput = $('[data-pgu-selling-plan]', box);

    // Scope live/total nodes to the section so the sticky bar (outside the box)
    // is also updated.
    var section = box.closest('.pgu-pdp') || document;
    var livePriceNodes = $$('[data-pgu-live-price]', section);
    var addTotalNodes = $$('[data-pgu-add-total]', section);
    var addButtons = $$('[data-pgu-buybox-add]', section);

    var state = {
      ptype: 'one-time',
      basePrice: 0,       // cents, from selected pack
      variantId: '',
      quantity: 1
    };

    /* ---- selection helpers ---- */

    function selectedPack() {
      for (var i = 0; i < packs.length; i++) {
        if (packs[i].classList.contains('is-active')) return packs[i];
      }
      return packs[0] || null;
    }

    function computeTotal() {
      var cents = state.basePrice;
      if (state.ptype === 'subscribe') {
        cents = Math.round(cents * (100 - discount) / 100);
      }
      return cents;
    }

    function render() {
      var total = computeTotal();
      var money = formatMoney(total);
      livePriceNodes.forEach(function (n) { n.textContent = money; });
      addTotalNodes.forEach(function (n) { n.textContent = money; });
    }

    function applyPack(pack) {
      if (!pack || pack.hasAttribute('disabled')) return;
      packs.forEach(function (p) {
        var active = p === pack;
        p.classList.toggle('is-active', active);
        p.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      state.basePrice = parseInt(pack.getAttribute('data-price'), 10) || 0;
      var vId = pack.getAttribute('data-variant');
      if (vId) {
        state.variantId = vId;
        if (variantSelect) variantSelect.value = vId;
      }
      render();
    }

    function applyPtype(value) {
      state.ptype = value === 'subscribe' ? 'subscribe' : 'one-time';

      $$('[data-pgu-ptype-card]', box).forEach(function (card) {
        var input = $('[data-pgu-ptype]', card);
        card.classList.toggle('is-active', !!input && input.value === state.ptype);
      });

      if (sellingPlanInput) {
        sellingPlanInput.value =
          (state.ptype === 'subscribe' && sellingPlanId) ? sellingPlanId : '';
      }
      render();
    }

    /* ---- bind ---- */

    ptypeInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) applyPtype(input.value);
      });
    });

    packs.forEach(function (pack) {
      pack.addEventListener('click', function () { applyPack(pack); });
    });

    /* ---- add to cart ---- */

    function openDrawer() {
      var drawer = $('[data-pgu-drawer]');
      if (!drawer) return;
      if (typeof drawer.__pguOpen === 'function') drawer.__pguOpen();
      else drawer.classList.add('is-open');
    }

    function updateCount(cart) {
      var n = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
      if (n === null) return;
      $$('[data-pgu-cart-count], .pgu-cart-count').forEach(function (el) {
        el.textContent = n;
        el.classList.toggle('is-empty', n <= 0);
      });
    }

    function doAdd(btn) {
      if (!state.variantId) return;
      if (btn) btn.classList.add('is-loading');

      var payload = { id: state.variantId, quantity: state.quantity };
      if (state.ptype === 'subscribe' && sellingPlanId) {
        payload.selling_plan = sellingPlanId;
      }

      var done = function () { if (btn) btn.classList.remove('is-loading'); };
      var fail = function (err) { if (window.console) console.warn('[pgu-buybox]', err); };

      // Prefer the theme's cart module: it adds, RE-RENDERS the drawer from the
      // real cart, and opens it — so the drawer always shows the true contents.
      if (window.PGU && window.PGU.cart && typeof window.PGU.cart.addToCart === 'function') {
        window.PGU.cart.addToCart(payload)
          .then(done)
          .catch(function (err) { fail(err); done(); });
        return;
      }

      // Fallback (theme cart module unavailable): standalone add + count.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add.js failed: ' + res.status);
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('cart.js failed: ' + res.status);
          return res.json();
        })
        .then(function (cart) { updateCount(cart); openDrawer(); })
        .catch(fail)
        .then(done);
    }

    addButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        doAdd(btn);
      });
    });

    /* ---- sticky mobile bar visibility ---- */
    var sticky = $('[data-pgu-buybox-sticky]', section);
    var primaryAdd = box.querySelector('.pgu-bb__add');
    if (sticky && primaryAdd && 'IntersectionObserver' in window) {
      sticky.setAttribute('aria-hidden', 'false');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(primaryAdd);
    }

    /* ---- init state ---- */
    var startPack = selectedPack();
    if (startPack) applyPack(startPack);
    else if (variantSelect) {
      state.variantId = variantSelect.value;
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (opt) state.basePrice = parseInt(opt.getAttribute('data-price'), 10) || 0;
    }
    applyPtype('one-time');
    render();
  }

  function boot() {
    $$('[data-pgu-buybox]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
